import { BrandName } from '@/scopes/common/domain/types'

export const BRAND: Record<string, BrandName> = {
  SUNWEB: 'sunweb',
  ELIZA: 'eliza',
}

export const SUMMER_PATHS = [
  '/vakantie/',
  '/nl/vakantie/',
  '/fr/vacances/',
  '/solresor/',
  '/rejser/',
  '/vacances/',
] as const
